<template>
  <div class="row row--new">
    <div class="row__name row__name_w156">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.0634766 2.32379H9.58729V3.91109H0.0634766V2.32379ZM0.0634766 5.49839H9.58729V7.08569H0.0634766V5.49839ZM12.7619 5.49839H11.1746V8.67299H8.00003V10.2603H11.1746V13.4349H12.7619V10.2603H15.9365V8.67299H12.7619V5.49839ZM6.41268 10.2603H0.0634766V8.673H6.41268V10.2603Z"
          fill="#9BCD82"
        />
      </svg>
      {{ request.service.title }}
    </div>
    <calendar-day-time>
      <div
        class="request"
        @click="openOrderModal(request.id)"
        :style="{
          left: _getHoursOffset(request.should_started_at, 1440, 40),
          width: getWidthBlock(
            request.should_started_at,
            request.predicted_time
          ),
        }"
      >
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50685 7.34564H4.54346C3.60824 7.34564 2.8501 7.95118 2.8501 8.69815V21.8851C2.8501 22.6321 3.60824 23.2376 4.54346 23.2376H17.2437C18.1789 23.2376 18.9371 22.6321 18.9371 21.8851V8.69815C18.9371 7.95118 18.1789 7.34564 17.2437 7.34564H14.2803"
            stroke="#9BCD82"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.25089 6.50922H12.5359C13.0804 6.50922 13.6027 6.72952 13.9877 7.12167C14.3727 7.51382 14.5891 8.04568 14.5891 8.60026V8.60026H7.19775V8.60026C7.19775 8.04568 7.41407 7.51382 7.7991 7.12167C8.18414 6.72952 8.70637 6.50922 9.25089 6.50922Z"
            stroke="#9BCD82"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <ellipse
            cx="10.6759"
            cy="5.25463"
            rx="1.30435"
            ry="1.25463"
            stroke="#9BCD82"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.8501 12L10.8501 20"
            stroke="#9BCD82"
            stroke-linecap="square"
          />
          <path
            d="M6.8501 16L14.8501 16"
            stroke="#9BCD82"
            stroke-linecap="square"
          />
          <circle
            cx="18.8501"
            cy="6"
            r="5"
            fill="#D53E29"
            stroke="none"
            stroke-width="2"
          />
        </svg>
      </div>
    </calendar-day-time>

    <div class="row__stats"></div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import calendarDayTime from '@/components/calendars/day/calendarDayTime'
import calendar from '@/mixins/calendar'

export default {
    name: 'calendar-new-item-day',
    props: {
        request: {
            required: true,
        },
        view: {
            required: true,
        },
    },
    mixins: [calendar],
    components: {
        calendarDayTime,
    },
    methods: {
        ...mapActions({
            fetchById: 'orders/fetchById',
        }),
        ...mapMutations({
            setToggleModal: 'orders/setToggleModal',
        }),
        getWidthBlock(date_from, predicted_time) {
            const localPredictedTime = predicted_time.toString()
            const wholeTime = 600

            const splittedTime = localPredictedTime.split('.')

            if (splittedTime[1] === undefined) {
                // if time is 1h [without minutes]
                const final = `${((splittedTime[0] * 60) / wholeTime) * 100}%`
                return final === '0%' ? '8.1%' : final
            } else {
                const final = parseFloat(splittedTime[0]) * 60 + parseFloat(splittedTime[1])
                return `${(final / wholeTime) * 100}%`
            }
        },
        getTop(line, index) {
            return `${index * 15 + 5}px`
        },
        async getRequestDetails(id) {
            this.$store.state.calendar.showDetails = false

            this.$Progress.start()
            await this.$store.dispatch('getRequestDetails', id)
            this.$store.state.calendar.showDetails = true
            this.$Progress.finish()
        },
        async openOrderModal(v) {
            await this.fetchById(v)
            this.setToggleModal()
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";
// .row {
//   height: 50px;
//   display: flex;
//   border-bottom: solid 1px #f3f3f3;

//   &_header {
//     background-color: rgba(97, 66, 45, 0.05);
//   }

//   &__name {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     color: rgba(#4d4d4d, 0.5);
//     font-family: $fontMedium;
//     font-size: 16px;
//     max-width: 120px;
//     width: 100%;
//     border-right: 1px solid rgba(77, 77, 77, 0.3);
//     @include respond(desktop) {
//       font-size: 14px;
//     }
//   }

//   &__stats {
//     max-width: 290px;
//     min-width: 150px;
//     width: 100%;
//     z-index: 999999999999;
//     background-color: #fff;
//   }

//   &__times {
//     position: relative;
//     width: 100%;
//     display: flex;

//     & .time {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       width: calc(100% / 10);
//       color: rgba(#4d4d4d, 0.5);
//       font-family: $fontMedium;
//       font-size: 16px;
//       box-sizing: border-box;
//       min-width: 45px;
//       position: relative;
//       border-right: 1px solid rgba(77, 77, 77, 0.3);

//       @include respond(desktop) {
//         min-width: 39px;
//         font-size: 13px;
//       }
//     }
//   }

//   &--new {
//     cursor: pointer;

//     & .row__name {
//       justify-content: flex-start;
//       border-top: 1px solid #71bd4a;
//       padding-left: 16px;
//       box-sizing: border-box;
//       color: #4d4d4d;
//       font-size: 10px;

//       & img {
//         margin-right: 10px;
//         width: 24px;
//       }
//     }

//     & .time span {
//       display: block;
//       width: 100%;
//       height: 100%;
//       background-color: rgba(#71bd4a, 0.1);
//     }

//     & .request {
//       position: absolute;
//       top: 9px;
//       height: 30px;
//       border-radius: 8px;
//       box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//       background-color: #71bd4a;
//       color: #ffffff;
//       font-size: 12px;
//       font-family: $fontBold;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       text-align: center;
//       width: 40px;
//       z-index: 9999999999;
//     }
//   }

//   &--service {
//     height: auto;
//     min-height: 80px;

//     & .row__name {
//       border-top: 1px solid #979797;
//       justify-content: flex-start;
//       padding-left: 16px;
//       box-sizing: border-box;
//       color: #4d4d4d;
//       font-size: 10px;

//       & img {
//         margin-right: 10px;
//         width: 24px;
//       }
//     }

//     & .line {
//       position: absolute;
//       display: inline-block;
//       height: 7px;
//       cursor: pointer;
//       transition: 0.5s;

//       &:hover {
//         transform: scale(1.2);
//         height: 7px;
//       }
//     }
//   }

//   &--image {
//     width: 30px;
//     height: 30px;
//     border: solid 1px $secondColor;
//     background-size: cover;
//     background-position: center;
//     border-radius: 50%;
//     margin-right: 10px;
//     flex-shrink: 0;
//   }
// }
// .row {
//   &__stats {
//     max-width: 290px;
//     min-width: 150px;
//     width: 100%;
//   }
// }
</style>
